module.exports = __webpack_public_path__ + "static/mo13-4cb67967a2032fa38baf2eab1e2298d5.png";